export function OpenChatBot(WebchatPageUrl: string, anyQuestionsText?: string) {
  if (
    document.getElementsByClassName('modal-webchat is-active') == null ||
    document.getElementsByClassName('modal-webchat is-active') == undefined ||
    document.getElementsByClassName('modal-webchat is-active').length == 0
  ) {
    var chatbutton =
      '<button class="chat-trigger-button" id = "btnChatTrigger" style="display: none;">' +
      '<span class="chat-trigger-button__text">' +
      anyQuestionsText +
      '</span>' +
      '<svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M4.36172 20.5101C4.24661 20.5101 4.13009 20.482 4.02621 20.4244C3.80019 20.3009 3.6598 20.0651 3.6598 19.8081V16.0908H2.97473C1.33505 16.0908 0 14.7557 0 13.1147V2.97614C0 1.33505 1.33505 0 2.97473 0H18.3468C19.9878 0 21.3229 1.33505 21.3229 2.97614V13.1147C21.3229 14.7557 19.9878 16.0908 18.3468 16.0908H11.4272L4.74216 20.3978C4.62705 20.4722 4.49509 20.5101 4.36172 20.5101ZM2.97473 1.40384C2.10856 1.40384 1.40384 2.10856 1.40384 2.97614V13.1147C1.40384 13.9822 2.10856 14.6869 2.97473 14.6869H4.36172C4.74918 14.6869 5.06364 15.0014 5.06364 15.3889V18.5208L10.8404 14.7993C10.9541 14.7263 11.0861 14.6869 11.2209 14.6869H18.3468C19.2143 14.6869 19.9191 13.9822 19.9191 13.1147V2.97614C19.9191 2.10856 19.2143 1.40384 18.3468 1.40384H2.97473Z" fill="white" />' +
      '<path d="M22.2705 24C22.1385 24 22.0051 23.9621 21.89 23.8877L15.205 19.5808H9.4043V18.1769H15.4113C15.5461 18.1769 15.678 18.2162 15.7918 18.2892L21.5686 22.0108V18.8789C21.5686 18.4914 21.883 18.1769 22.2705 18.1769H23.6575C24.5236 18.1769 25.2284 17.4722 25.2284 16.6046V6.46613C25.2284 5.59855 24.5236 4.89383 23.6575 4.89383H22.4417V3.48999H23.6575C25.2971 3.48999 26.6322 4.82504 26.6322 6.46613V16.6046C26.6322 18.2457 25.2971 19.5808 23.6575 19.5808H22.9724V23.2981C22.9724 23.555 22.832 23.7909 22.606 23.9144C22.5007 23.972 22.3856 24 22.2705 24Z" fill="white" />' +
      '<path d="M5.35156 8.26864C5.35156 8.8035 5.78675 9.23869 6.32161 9.23869C6.85648 9.23869 7.29307 8.8035 7.29307 8.26864C7.29307 7.73377 6.85788 7.29858 6.32161 7.29858C5.78535 7.29858 5.35156 7.73377 5.35156 8.26864Z" fill="white" />' +
      '<path d="M10.661 9.23869C11.1967 9.23869 11.631 8.80438 11.631 8.26864C11.631 7.73289 11.1967 7.29858 10.661 7.29858C10.1252 7.29858 9.69092 7.73289 9.69092 8.26864C9.69092 8.80438 10.1252 9.23869 10.661 9.23869Z" fill="white" />' +
      '<path d="M15.0003 9.23869C15.5361 9.23869 15.9704 8.80438 15.9704 8.26864C15.9704 7.73289 15.5361 7.29858 15.0003 7.29858C14.4646 7.29858 14.0303 7.73289 14.0303 8.26864C14.0303 8.80438 14.4646 9.23869 15.0003 9.23869Z" fill="white" />' +
      '</svg>' +
      '</button>';

    var divParent = document.createElement('div');
    divParent.className = 'modal-webchat';
    divParent.id = 'webchat';

    var divChild = document.createElement('div');
    divChild.className = 'chat-button';
    divChild.innerHTML = chatbutton;

    var div = document.createElement('div');
    //div.className = 'modal-overlay';
    div.id = 'showIframe';
    var iframe = document.createElement('iframe');
    iframe.className = 'iframe-chat';
    iframe.id = 'overlay';
    iframe.setAttribute(
      'src',
      window.location.origin + '/webchat/ChatRequestLongPolling.html',
    );
    iframe.setAttribute(
      'name',
      WebchatPageUrl,
    );
    iframe.setAttribute(
      'fromPortalPage',
      'true'
    );
    div.appendChild(iframe);
    divParent.appendChild(divChild);
    divParent.appendChild(div);
    document.body.appendChild(divParent);
    div.style.display = 'block';
    const btnChatTrigger = document.getElementById('btnChatTrigger');
    console.log('btnChatTrigger', btnChatTrigger);
    if (btnChatTrigger !== null) {
      btnChatTrigger.onclick = function () {
        divParent.className = 'modal-webchat';
        btnChatTrigger.style.display = 'none';
        div.style.display = 'block';
        iframe.style.display = 'block';
        iframe.setAttribute(
          'src',
          window.location.origin + '/webchat/ChatRequestLongPolling.html',
        );
      };
    }
  }
}
